// extracted by mini-css-extract-plugin
export default {"ImgInfoSection":"ImgInfo_ImgInfoSection__iaEpF","ImgInfoTextContainer":"ImgInfo_ImgInfoTextContainer__MqVFC","ImgInfoImgContainer":"ImgInfo_ImgInfoImgContainer__gGS9T"};